import styled from 'styled-components'
import { communicationButtonCss } from '~/pages/communication/libs/communicationBaseStyles'

export const CommunicationScratchStyles = {
  ContinueButton: styled.button`
    ${communicationButtonCss}
    margin-top: 32px;
    width: 100%;
  `,
}
